import type { ComponentChildren, FunctionalComponent } from 'preact';

import { cnBlockBubbledCard1 } from '../block-bubbled-card-1.constants.js';

import './block-bubbled-card-1__body.css';

export interface BlockBubbledCard1BodyProps {
    className?: string;
    children?: ComponentChildren;
}

export const BlockBubbledCard1Body: FunctionalComponent<BlockBubbledCard1BodyProps> = ({ children, className }) => (
    <div className={cnBlockBubbledCard1('body', [className])}>{children}</div>
);
